module.exports = {"320211001":"河埒街道","320211002":"荣巷街道","320211003":"蠡园街道","320211004":"蠡湖街道","320211006":"华庄街道","320211007":"太湖街道","320211008":"雪浪街道","320211009":"马山街道","320211101":"胡埭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320211.json
// module id = 941
// module chunks = 0